import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LoadingService,
  LoadingState,
} from '../../../core/services/loading/loading.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
})
export class LoadingComponent {
  public loadingState$: Observable<LoadingState>;

  constructor(private readonly loadingService: LoadingService) {
    this.loadingState$ = this.loadingService.loadingState$;
  }
}
